<template>
  <div class="stoveTemper">
    <div class="wrapper">
      <div class="headerTop">
        <a-icon type="instagram" /><span>{{data.title}}</span
        ><a-button type="primary" size="small"> {{data.title}} 环保在线监测 </a-button>
      </div>
      <div class="table">
        <div class="tableHeader">
          <div v-for="item in data.list" :key="item.index">
            <div class="listItem">{{ item }}</div>
          </div>
        </div>
        <div class="content">
          <div>
            <div v-for="item in data.info.nameArr" :key="item.index">
              <div class="nameArrItem">{{ item }}</div>
            </div>
          </div>
          <div>
            <div v-for="item in data.info.currentTemArr" :key="item.index">
              <div class="currentArrItem">{{ item}}</div>
            </div>
          </div>
          <!-- <div>
            <div v-for="item in ttt.maxTemArr" :key="item.index">
              <div class="maxArrItem">{{ item }}°c</div>
            </div>
          </div>
          <div>
            <div v-for="item in ttt.mixTemArr" :key="item.index">
              <div class="mixArrItem">{{ item }}°c</div>
            </div>
          </div> -->
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      list: ["窑炉状态", "实时信息"],
      ttt: {
        nameArr: [
          "二氧化硫",
          "氧气含量",
          "烟尘浓度",
          "烟尘流速",
          "炉底南",
          "炉底南",
          "炉底南",
          "炉底南",
          "炉底南",
          "炉底南",
          "炉底南",
          "炉底南",
          "炉底南",
          "炉底南",
          "炉底南",
          "炉底南",
        ],
        currentTemArr: [
          "16",
          "21",
          "25",
          "35",
          "22",
          "12",
          "21",
          "23",
          "16",
          "21",
          "25",
          "35",
          "22",
          "12",
          "21",
          "23",
        ],
        // maxTemArr: [
        //   "35",
        //   "28",
        //   "45",
        //   "55",
        //   "46",
        //   "89",
        //   "78",
        //   "25",
        //   "35",
        //   "28",
        //   "45",
        //   "55",
        //   "46",
        //   "89",
        //   "78",
        //   "25",
        //   "35",
        //   "28",
        //   "45",
        //   "55",
        //   "46",
        //   "89",
        //   "78",
        //   "25",
        // ],
        // mixTemArr: [
        //   "10",
        //   "15",
        //   "5",
        //   "15",
        //   "20",
        //   "30",
        //   "25",
        //   "40",
        //   "10",
        //   "15",
        //   "5",
        //   "15",
        //   "20",
        //   "30",
        //   "25",
        //   "40",
        // ],
      },
    };
  },
  props:{
    data:{
      type:Object
    }
  },
  methods: {},
};
</script>
<style scoped>
.wrapper {
  color: #fff;
  width: 100%;
  display: flex;
  flex-direction: column;
  background-color: #1f2b39;
  height: 460px;
}
.headerTop span {
  font-size: 18px;
  padding-right: 30px;
  padding-left: 10px;
}
.tableHeader {
  display: flex;
  flex-direction: row;
  justify-content: center;
  padding-top: 10px;
}
.listItem {
  width: 85px;
}
.nameArrItem,
.maxArrItem,
.mixArrItem {
  width: 60px;
  height: 30px;
  color: #7b828b;
  font-size: 12px;
}
.currentArrItem {
  width: 57px;
  height: 30px;
  color: #ab383e;
}
.table{
  width: 100%;
  position: relative;
  overflow: hidden;
  height: 400px;
}
.content {
  width: 100%;
  display: flex;
  justify-content: space-between;
  padding-top: 10px;
  overflow-y: scroll;
  position: absolute;
  right: -17px;
  overflow-x: hidden;
  height: 400px;
  padding-right: 17px;
}
</style>


// WEBPACK FOOTER //
// src/components/test10Children/stoveTemper.vue